import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, Button, Form, Input } from 'antd'

import logo from '../../assets/images/logo.svg'
import { LinkWrapper, CardTitle, Logo } from '../LoginPage/styles'

import { Link } from '../../components'
import {http, message} from "../../utils";
import {API_BASE_URL} from "../../constants";
import { UserOutlined } from "@ant-design/icons";
import hLogo from "../../assets/logo/H.svg";

import HefeosLogo from '../../assets/Hefeos-IQT-Dark.svg'


class ResendEmail extends Component {

  state = {
    isSendingEmail: false,
  }

  handleClick = (values) => {
    this.setState({isSendingEmail:true})
    http
      .post(`${API_BASE_URL}/auth/resend-verification`, values)
      .then(()=>{
        this.setState({isSendingEmail:false})
        message.show(message.type.success, 'A new verification email has been sent.')
        this.props.history.push('/login')
      })
      .catch(error=>{
        this.setState({isSendingEmail:false})
        message.show(message.type.error, http.getErrorMessage(error))
      })
  }


  render() {
    const {history} = this.props
    return (
      <div className={"publicWrapper"}>
        <div className={"tiledBackground"}>
          <Card className={"publicCard"}>
            <div style={{ textAlign: 'center', marginTop: 20, marginBottom: "6em" }}>
              <img src={HefeosLogo} alt={"Hefeos Logo"} width={300}/>
            </div>
            <CardTitle className={"signInText"}>Resend Verification Email</CardTitle>
            <div className={"loginLabel"} style={{ marginBottom: 18}}>
              Enter your email address below and we'll send you a link to verify your account.
            </div>
            <Form
              name={'forgot-password'}
              onFinish={this.handleClick}
            >
              <span className={"loginLabel"}>Email</span>
              <Form.Item
                name={'email'}
                rules={[
                  {required: true, message: 'This field is required'},
                  {type: 'email', message: 'Please enter a valid email address'},
                ]}
                validateTrigger={'onSubmit'}
              >
                <Input
                  placeholder="Enter your email address"
                  prefix={<UserOutlined />}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  style={{ width: '100%', marginTop: 15}}
                  loading={this.state.isSendingEmail}
                  type="primary"
                  htmlType="submit"
                  className={"loginText darkButton"}
                >
                  Resend Email
                </Button>
              </Form.Item>
            </Form>
            <LinkWrapper>
              <Link to="/login" history={history}>
                Already have an account? Sign in!
              </Link>
            </LinkWrapper>
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ }, dispatch)

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResendEmail)
)
